// extracted by mini-css-extract-plugin
export default {"modal":"qF4wUmLoyEnPCN0LdjHP__modal___","modalDescription":"j9IQYC0uyLXwu2kquQiO__modalDescription___"};